import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DefensePlaySelection } from "./DefensePlaySelection";
import { DefensePlayLog } from "./DefensePlayLog";
import { DefenseTackleLog } from "./DefenseTackleLog";
import { useLogger } from "../../../../contexts/LoggerContext";
import { DefenseTurnoverLog } from "./DefenseTurnoverLog";
import { PenaltyLog } from "../Components/PenaltyLog";
import { useDepthChart } from "../../../../contexts/DepthChartContext";

export const DefenseLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  const { clearSelections } = useLogger();
  const { defensePlayers } = useDepthChart();

  useEffect(() => {
    if (clearSelections) {
      setExpandedAccordion("play-selection");
    }
  }, [clearSelections]);

  return (
    <Paper elevation={3} sx={{ p: 1, maxWidth: 1137 }}>
      <Box>
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DefensePlaySelection />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "play-log"}
          onChange={handleAccordionChange("play-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-log-content"
            id="play-log-header"
          >
            <Typography>Play Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DefensePlayLog />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expandedAccordion === "tackle-log"}
          onChange={handleAccordionChange("tackle-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="tackle-log-content"
            id="tackle-log-header"
          >
            <Typography>Tackle Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DefenseTackleLog />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expandedAccordion === "takeaway-log"}
          onChange={handleAccordionChange("takeaway-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="takeaway-log-content"
            id="takeaway-log-header"
          >
            <Typography>Takeaway Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DefenseTurnoverLog />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="penalty-log-content"
            id="penalty-log-header"
          >
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PenaltyLog players={defensePlayers} />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};
